import React from 'react';
import Dialog from 'material-ui/Dialog';

export default class MissingInfo extends React.Component {
  state = {
    modalOpen: true
  };

  render() {
    return (
      <Dialog title="Before you book your first shift..." modal open={this.state.modalOpen} className="text-center missing-info" autoScrollBodyContent={true}>
        <p className="bank-msg">Please update your profile with your banking information so you will be ready to receive earnings</p>
        <a href="/profile" className="profile-link"><button className="profile-button">Update Profile</button></a>
      </Dialog>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/User/MissingInfo.js